import { useState, useEffect } from "react";

import { LoadMore } from "@/app/shared-components/cta-button/cta-buttons";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { QuoteReview } from "@/config/app-constant";
import fetchHelpOverlay from "@/hooks/magnolia/fetch-help-overlay";

function CookiePolicyButton() {
  const [label, setLabel] = useState<string>("");

  const { current } = useWizard();
  const currentPage = current?.id || "";

  useEffect(() => {
    const fetchLabel = async () => {
      try {
        const res = await fetchHelpOverlay("highRisk");
        setLabel(res?.ctaCookieBtnLabel ?? "Cookie policy");
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching help overlay:", error);
        setLabel("Cookie policy");
      }
    };

    fetchLabel();
  }, []);

  const handleOpenCookieSettings = () => {
    if (typeof window !== "undefined") {
      window.open(
        "https://www.staysure.co.uk/cookie-policy/",
        "_blank",
        "noopener,noreferrer"
      );
    }
  };
  return (
    <div
      className={`mt-spacing-m text-surface-neutral-option-7 font-body-font text-[12px] leading-[18px] font-semibold ${
        currentPage !== QuoteReview ? "lg:mx-[72px]" : "lg:mx-auto"
      } xl:mx-0
                 md:mx-[48px] mx-[24px] md:flex `}
    >
      <LoadMore
        label={label || "Cookie policy"}
        onClick={handleOpenCookieSettings}
        isRightIcon={false}
        className="text-text-on-secondary text-center hover:bg-interactive-secondary-pressed body-font text-2xs font-semibold
                leading-[18px] underline underline-offset-4 hover:underline hover:text-neutral-50"
      />
    </div>
  );
}

export default CookiePolicyButton;
